// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"264":"commons","348":"component---src-pages-keynote-speaking-js","936":"component---src-pages-index-js"}[chunkId] + "-" + {"264":"1fc0f81c8d5db210d0e2","348":"d9097e6109cb38200abc","936":"fceca955338f3a440ed2"}[chunkId] + ".js";
};